import { AccountNetworksList } from '~/components/AccountNetworksList'
import { SplitsLink } from '~/components/Link'
import { Copyable } from '~/components/component-library'
import { IAddress } from '~/types'

export const ReceiveDialogContent = ({ address }: { address: IAddress }) => {
  return (
    <>
      <Copyable
        layout="field"
        label="Address"
        description="Send tokens and NFTs on all supported networks"
        value={address}
        truncateMiddle
        footer={
          <span>
            Learn more about asset support{' '}
            <SplitsLink
              path="https://splits.org/docs/introduction/networks-and-assets"
              target="tab"
              className="underline"
            >
              here
            </SplitsLink>
            .
          </span>
        }
      />
      <AccountNetworksList address={address} />
    </>
  )
}
